'use es6';

import { Fragment } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ScopesList from './ScopesList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScopesCollection = ({
  scopesCollection
}) => {
  if (!scopesCollection || !scopesCollection.length) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "developer-docs-shared-components.requirements.scopes.noScopes"
    });
  }
  return /*#__PURE__*/_jsx("div", {
    children: scopesCollection.map((scopes, index) => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ScopesList, {
        scopes: scopes
      }), index < scopesCollection.length - 1 && /*#__PURE__*/_jsx(FormattedMessage, {
        useGap: true,
        message: "developer-docs-shared-components.requirements.scopes.orSeparator"
      })]
    }, `${scopes[0]}-${index}`))
  });
};
ScopesCollection.propTypes = {
  // Each nestedArray scopesCollection represents an "or" scope relationship.
  scopesCollection: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
export default ScopesCollection;